<template>
    <div v-if="dataProduct.discount"
    :class="'position-absolute p-2 shadow-sm text-center d-flex justify-content-center align-items-center '
    +(dataClasses ? dataClasses : 'top-0 start-0 bg-light')">
        <div>
            {{ this.__('global', 'now' ) }}
            <div v-if="dataProduct.discount_type === 'percentage'" class="h4 mb-0">-{{ dataProduct.discount }}%</div>
            <div v-else class="h4 mb-0">-{{ this.amountWithCurrency(dataProduct.discount) }}</div>
            {{ this.__('global', 'off' ) }}
        </div>
    </div>
</template>
<script>
    export default {
        props: ['dataProduct', 'dataClasses'],
    };
</script>
